import type { Root } from 'hast';
import { SKIP, visit } from 'unist-util-visit';

import replaceCmsUrl from '@/utils/functions/wordpress/replace-cms-url';

const internalLinkingFix = () => {
    return (tree: Root) => {
        visit(tree, 'element', node => {
            if (
                node.tagName === 'a' &&
                typeof node.properties?.href === 'string' &&
                node.properties?.href?.includes('cms.blockworks.co')
            ) {
                node.properties.href = replaceCmsUrl(node.properties?.href);
                return [SKIP];
            }
            return [];
        });
    };
};

export default internalLinkingFix;
